<template>
    <div>
        <v-row v-if="!loadingsaved">
            <v-col cols="6">
                <v-card elevation="0" outlined>
                    <v-card-title class="text-h6">Attachment Types</v-card-title>
                    <v-card-subtitle>Attachment types allow applicants to classify the documents they upload</v-card-subtitle>
                    <v-card-text>
                        <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr v-for="item in attachtypes" :key="item">
                                        <td>{{ item }}</td>
                                        <td style="text-align: right;">
                                            <v-btn icon color="#F51720" x-small @click="deleteType(item)" :loading="deletetypeloading"><v-icon>mdi-trash-can</v-icon></v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table><br />
                        <v-text-field outlined label="New Type" dense v-model="newType" hide-details>
                            <template v-slot:append-outer>
                                <v-btn @click="addType" :loading="addtypeloading" icon color="#0E86D4" small>
                                    <v-icon>mdi-plus-thick</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-card-text>
                </v-card> 
            </v-col>
            <v-col cols="6">
                <v-card elevation="0" outlined>
                    <v-card-title class="text-h6">Salary Grid</v-card-title>
                    <v-card-subtitle>This grid will be shown as a salary in COURSE postings.</v-card-subtitle>
                    <v-card-text>
                        <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Effective Date as of May 1</th>
                                        <th>0.5 Course Load</th>
                                        <th>1.0 Course Load</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in salarygrid" :key="item">
                                        <td>{{ item.year }}</td>
                                        <td>${{ item.halfcourse }}</td>
                                        <td>${{ item.fullcourse }}</td>
                                        <td style="text-align: right;">
                                            <v-btn icon color="#F51720" x-small @click="deleteSalaryItem(item)" :loading="deletesalaryloading"><v-icon>mdi-trash-can</v-icon></v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table><br />
                        <v-row align="center">
                            <v-col cols="4">
                                <v-text-field outlined label="Date" v-model="newSalaryField.year" dense hide-details></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field outlined label="0.5 Course" v-model="newSalaryField.halfcourse" prefix="$" dense hide-details></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field outlined label="1.0 Course" v-model="newSalaryField.fullcourse" prefix="$" dense hide-details>
                                    <template v-slot:append-outer>
                                        <v-btn @click="addSalaryItem" :loading="addsalaryloading" icon color="#0E86D4" small>
                                            <v-icon>mdi-plus-thick</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card> 
            </v-col>
            <v-col cols="6">
                <v-card elevation="0" outlined>
                    <v-card-title class="text-h6">CUPE Seniority List URL</v-card-title>
                    <v-card-text>
                        <v-text-field outlined label="Seniority List URL" dense v-model="seniorityurl"
                            append-icon="mdi-link" @click:append="testURL" hide-details
                        >
                            <template v-slot:append-outer>
                                <v-btn @click="updateURL" :loading="seniorityloading" icon color="#0E86D4" small>
                                    <v-icon>mdi-floppy</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-card-text>
                </v-card> 
            </v-col>
        </v-row>
        <v-row 
            class="fill-height"
            align-content="center"
            justify="center"
            v-else
        >
            <v-container style="height: 400px;">
                <v-row
                    class="fill-height"
                    align-content="center"
                    justify="center"
                >
                    <v-col
                        class="text-subtitle-1 text-center"
                        cols="12"
                    >
                        Calling saved controls...
                    </v-col>
                    <v-col cols="6">
                        <v-progress-linear
                            color="#80CBC4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-container>
        </v-row>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            loadingsaved: true,
            attachtypes: [],
            newType: "",
            seniorityurl: "",
            newSalaryField: {
                year: "",
                halfcourse: "",
                fullcourse: ""
            },
            salarygrid: [],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            addtypeloading: false,
            seniorityloading: false,
            deletetypeloading: false,
            addsalaryloading: false,
            deletesalaryloading: false,
        }
    },
    methods: {
        initialize(){
            const that = this;
            that.loadingsaved = true;
            that.attachtypes = [];
            that.seniorityurl = "";
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            json.data.forEach(element => {
                                if(element["type"] == "attachtypes"){
                                    that.attachtypes = element["config"]["doctypes"];
                                }

                                if(element["type"] == "seniorityURL"){
                                    that.seniorityurl = element["config"]["url"];
                                }

                                if(element["type"] == "salary"){
                                    that.salarygrid = element["config"]["grid"];
                                }
                            });
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }

                    that.loadingsaved = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.loadingsaved = false;
                })
        },
        deleteType(item){
            const that = this;
            var attach = that.attachtypes;
            let index = attach.indexOf(item);
            if(index > -1){
                that.deletetypeloading = true;
                attach.splice(index, 1);

                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
                let attaches = {
                    type: "attachtypes",
                    doctypes: attach
                };

                const formData = new FormData();

                formData.append("mode", "setFormControl");
                formData.append("data", JSON.stringify(attaches));

                //API calling
                fetch(api,{
                        method: "POST",
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (resultData) {
                        if(!resultData.result.match(/^OK/i)){
                            that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        }else {
                            that.setSnackbar("Deleted the selected attachment type!", "#388E3C"); //green

                            that.deletetypeloading = false;
                        }
                    })
                    .catch(function(err){
                        that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                        that.deletetypeloading = false;
                    })
                //End of API calling
            }
        },
        addType(){
            const that = this;

            if(that.newType.length >= 2){

                var attach = that.attachtypes;
                attach.push(that.newType);

                that.addtypeloading = true;
                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
                let attachtypes = {
                    type: "attachtypes",
                    doctypes: attach
                };

                const formData = new FormData();

                formData.append("mode", "setFormControl");
                formData.append("data", JSON.stringify(attachtypes));

                //API calling
                fetch(api,{
                        method: "POST",
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (resultData) {
                        if(!resultData.result.match(/^OK/i)){
                            that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        }else {
                            that.setSnackbar("Added new attachment type!", "#388E3C"); //green
                            that.newType = "";
                        }

                        that.addtypeloading = false;
                    })
                    .catch(function(err){
                        that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                        that.addtypeloading = false;
                    })
                //End of API calling
            }else {
                that.setSnackbar("Please enter at least 2 characters", "#FF8300");
            }
        },
        testURL(){
            const that = this;
            
            if(/^https:\/\/(.*)/.test(that.seniorityurl)){
                window.open(that.seniorityurl);
            }else {
                that.setSnackbar("Invalid URL - Must start with https://", "#FF8300");
            }
        },
        updateURL(){
            const that = this;
            that.seniorityloading = true;

            if(/^https:\/\/(.*)/.test(that.seniorityurl)){
                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
                let url = {
                    type: "seniorityURL",
                    url: that.seniorityurl
                };

                const formData = new FormData();

                formData.append("mode", "setFormControl");
                formData.append("data", JSON.stringify(url));

                //API calling
                fetch(api,{
                        method: "POST",
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (resultData) {
                        if(!resultData.result.match(/^OK/i)){
                            that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        }else {
                            that.setSnackbar("Updated Seniority List URL!", "#388E3C"); //green
                        }

                        that.seniorityloading = false;
                    })
                    .catch(function(err){
                        that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                        that.seniorityloading = false;
                    })
                //End of API calling
            }else {
                that.setSnackbar("Invalid URL - Must start with https://", "#FF8300");
            }
        },
        addSalaryItem(){
            const that = this;

            if(that.newSalaryField.year.length > 0 && that.newSalaryField.halfcourse.length > 0 && that.newSalaryField.fullcourse.length > 0){

                var newitem = that.salarygrid;
                newitem.push(that.newSalaryField);

                that.addsalaryloading = true;
                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
                let salary = {
                    type: "salary",
                    grid: newitem
                };

                const formData = new FormData();

                formData.append("mode", "setFormControl");
                formData.append("data", JSON.stringify(salary));

                //API calling
                fetch(api,{
                        method: "POST",
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (resultData) {
                        if(!resultData.result.match(/^OK/i)){
                            that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        }else {
                            that.setSnackbar("Updated Salary Grid", "#388E3C"); //green
                            that.newSalaryField = {
                                year: "",
                                halfcourse: "",
                                fullcourse: ""
                            };
                        }

                        that.addsalaryloading = false;
                    })
                    .catch(function(err){
                        that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                        that.addsalaryloading = false;
                    })
                //End of API calling
            }else {
                that.setSnackbar("Please enter salary values", "#FF8300");
            }
        },
        deleteSalaryItem(item){
            const that = this;
            var newitem = that.salarygrid;
            let index = newitem.indexOf(item);
            if(index > -1){
                that.deletesalaryloading = true;
                newitem.splice(index, 1);

                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
                let salary = {
                    type: "salary",
                    grid: newitem
                };

                const formData = new FormData();

                formData.append("mode", "setFormControl");
                formData.append("data", JSON.stringify(salary));

                //API calling
                fetch(api,{
                        method: "POST",
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (resultData) {
                        if(!resultData.result.match(/^OK/i)){
                            that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        }else {
                            that.setSnackbar("Deleted the selected salary info!", "#388E3C"); //green

                            that.deletesalaryloading = false;
                        }
                    })
                    .catch(function(err){
                        that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                        that.deletesalaryloading = false;
                    })
                //End of API calling
            }
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.initialize();
    }
}
</script>